<h4 class="fw-bold">{{ "forecasted_values.insert_values" | translate }}</h4>

@let data = model();

@if (data?.kpiId) {
    <adaa-data-entry-details [dataEntryDetails]="model()" />

    @if (!isMasterKPI()) {
        <adaa-kpi-forecasted-values [forecastedValuesDetails]="model()" (valueChanged)="valueChanged($event)" />
    } @else {
        <adaa-master-forecasted-values [forecastedValuesDetails]="model()" (valueChanged)="valueChanged($event)" />
    }
}

<adaa-form-action-buttons
    cancelButtonTitle="common.form.button.cancel"
    saveButtonTitle="common.form.button.submit"
    (saveClicked)="submit()"
    (cancelClicked)="goBack()"
/>
